import { getNormalStyles, getFullscreenStyles } from '../consts';
import { type DisplayModes } from '../types';

export const getDisplayModeToResponsiveStyles = (): Record<
  DisplayModes,
  { desktop: Partial<CSSStyleDeclaration>; mobile: Partial<CSSStyleDeclaration> }
> => ({
  NORMAL: {
    desktop: getNormalStyles(),
    mobile: getNormalStyles(),
  },
  FULLSCREEN: {
    desktop: getFullscreenStyles(),
    mobile: getFullscreenStyles(),
  },
});
